module.exports = __webpack_public_path__ + "static/media/cuttlewordlogo.80541a1c.png";